import { MonitorForCreatedAssetGroupKey } from 'areas/assets/monitors/shared-components/configuration';
import { MonitorBase } from 'areas/assets/monitors/shared-components/monitorBase';
import { translator } from 'core/localization';
import { Constructor } from 'framework/api';
import { deserialize, serialize } from 'serializr';

export const i18n = translator({
	'Create assetgroup': {
		no: 'Opprett assetgruppe',
	},
});
export type MonitorValue<T extends MonitorBase<T>> = MonitorBase<T> | { accountId: string };
export type GenericMonitorFactory = <T extends MonitorBase<T>>() => MonitorValue<T>;

export type AssetGroupMonitorEditProps<TMonitor extends MonitorBase<TMonitor>> = {
	monitor: MonitorValue<TMonitor> | GenericMonitorFactory;
	ignoreType?: boolean;
	onClick?: () => void;
};

export const applyToMonitorCachedData = (data?: { id: string }) => {
	const cachedMonitor = localStorage.getItem(MonitorForCreatedAssetGroupKey);
	if (cachedMonitor && cachedMonitor != 'undefined') {
		data ??= {} as { id: string };
		const monitor = JSON.parse(cachedMonitor) as { id: string };
		if (monitor.id == data.id) {
			Object.assign(data, monitor);
			localStorage.removeItem(MonitorForCreatedAssetGroupKey);
			return data;
		}
	}
	localStorage.removeItem(MonitorForCreatedAssetGroupKey);
	return data;
};

export const getMonitorUpdatesFromCache = <TMonitor extends MonitorBase<TMonitor>>(
	monitorConstructor: Constructor<TMonitor>,
	data: TMonitor,
) => {
	const cachedMonitor = localStorage.getItem(MonitorForCreatedAssetGroupKey);
	if (cachedMonitor && cachedMonitor != 'undefined') {
		const monitor = JSON.parse(cachedMonitor) as { id: string };
		if (monitor.id == data.id) {
			const monitorJs = serialize(monitorConstructor, data) as object;
			Object.assign(monitorJs, monitor);
			const updatedMonitor = deserialize(monitorConstructor, monitorJs);
			localStorage.removeItem(MonitorForCreatedAssetGroupKey);
			return updatedMonitor;
		}
	}
	localStorage.removeItem(MonitorForCreatedAssetGroupKey);
	return data;
};
